export var DATA_HOOKS = /*#__PURE__*/ function(DATA_HOOKS) {
    DATA_HOOKS["OPTION"] = "option";
    DATA_HOOKS["FIELD_SETTINGS_PANEL_ADD_NEW_OPTION_BUTTON"] = "add-new-option-button";
    DATA_HOOKS["FIELD_SETTINGS_PANEL_ADD_OTHER_OPTION"] = "add-other-option-toggle-switch";
    DATA_HOOKS["FIELD_SETTINGS_PANEL_OPTION_LABEL"] = "field-settings-panel-option-label";
    DATA_HOOKS["FIELD_SETTINGS_PANEL_BULK_EDIT_BUTTON"] = "field-settings-panel-bulk-edit-button";
    DATA_HOOKS["FIELD_SETTINGS_PANEL_BULK_EDIT_MODAL"] = "field-settings-panel-bulk-edit-modal";
    DATA_HOOKS["FIELD_SETTINGS_PANEL_BULK_EDIT_MODAL_LAYOUT"] = "field-settings-panel-bulk-edit-modal-layout";
    DATA_HOOKS["FIELD_SETTINGS_PANEL_LABEL_FORM_FIELD"] = "field-settings-label-form-field";
    DATA_HOOKS["FIELD_SETTINGS_PANEL_LABEL_INPUT"] = "field-settings-label";
    DATA_HOOKS["FIELD_SETTINGS_PANEL_CONTENT"] = "field-settings-panel-content";
    DATA_HOOKS["FIELD_SETTINGS_TABS"] = "field-settings-tabs";
    DATA_HOOKS["LABEL_MEDIA_TOGGLE"] = "label-media-toggle";
    DATA_HOOKS["LABEL_MEDIA_ADD_IMAGE"] = "label-media-add-image";
    DATA_HOOKS["LABEL_MEDIA_IMAGE_SETTINGS_MENU"] = "label-media-image-settings-menu";
    DATA_HOOKS["LABEL_MEDIA_IMAGE_SETTINGS_MENU_TRIGGER"] = "label-media-image-settings-menu-button";
    DATA_HOOKS["LABEL_MEDIA_DELETE_IMAGE"] = "label-media-delete-image";
    DATA_HOOKS["LABEL_MEDIA_IMAGE_SETTINGS"] = "label-media-image-settings";
    DATA_HOOKS["LABEL_MEDIA_IMAGE_FIT_TOGGLE"] = "label-media-image-fit-toggle";
    DATA_HOOKS["LABEL_MEDIA_IMAGE_FIT_COVER"] = "label-media-image-fit-cover";
    DATA_HOOKS["LABEL_MEDIA_IMAGE_FIT_CONTAIN"] = "label-media-image-fit-contain";
    DATA_HOOKS["LABEL_MEDIA_IMAGE_ALIGNMENT_TOGGLE"] = "label-media-image-alignment-toggle";
    DATA_HOOKS["LABEL_MEDIA_IMAGE_ALIGNMENT_LEFT"] = "label-media-image-alignment-left";
    DATA_HOOKS["LABEL_MEDIA_IMAGE_ALIGNMENT_CENTER"] = "label-media-image-alignment-center";
    DATA_HOOKS["LABEL_MEDIA_IMAGE_ALIGNMENT_RIGHT"] = "label-media-image-alignment-right";
    DATA_HOOKS["SHOW_FLAG_TOGGLE"] = "show-flag-toggle";
    DATA_HOOKS["DEFAULT_COUNTRY_TOGGLE"] = "default-country-toggle";
    DATA_HOOKS["DEFAULT_COUNTRY_DROPDOWN"] = "default-country-dropdown";
    DATA_HOOKS["DEFAULT_DESCRIPTION_TOGGLE"] = "description-toggle-switch";
    DATA_HOOKS["PLACEHOLDER_TOGGLE"] = "placeholder-toggle-switch";
    DATA_HOOKS["SHOW_DATE_LABELS_TOGGLE"] = "show-date-labels-toggle-switch";
    DATA_HOOKS["PLACEHOLDER_INPUT"] = "placeholder-input";
    DATA_HOOKS["OTHER_OPTION_INPUT"] = "other-option-input";
    DATA_HOOKS["DONATION_AMOUNT_OPTION"] = "donation-amount-option";
    DATA_HOOKS["DROPDOWN_DEFAULT_OPTION_TOGGLE"] = "default-view-toggle-switch";
    DATA_HOOKS["SIGNATURE_FIELD_MODE_SELECT"] = "signature-field-mode-select";
    DATA_HOOKS["CHECKED_BY_DEFAULT_TOGGLE"] = "checked-by-default-toggle-switch";
    DATA_HOOKS["ALLOWED_COUNTRIES_TOGGLE"] = "allowed-countries-toggle";
    DATA_HOOKS["ALLOWED_COUNTRIES_MODAL_TRIGGER"] = "allowed-countries-modal-trigger";
    DATA_HOOKS["ALLOWED_COUNTRIES_MODAL"] = "allowed-countries-modal";
    DATA_HOOKS["ALLOWED_COUNTRIES_MODAL_LAYOUT"] = "allowed-countries-modal-layout";
    DATA_HOOKS["ALLOWED_COUNTRIES_MODAL_SEARCH"] = "allowed-countries-modal-search";
    DATA_HOOKS["ALLOWED_COUNTRIES_MODAL_DESELECT_ALL"] = "allowed-countries-modal-deselect-all";
    DATA_HOOKS["ALLOWED_COUNTRIES_MODAL_SELECT_ALL"] = "allowed-countries-modal-select-all";
    DATA_HOOKS["ALLOWED_COUNTRIES_MODAL_FILTER"] = "allowed-countries-modal-filter";
    DATA_HOOKS["ALLOWED_COUNTRIES_MODAL_FILTER_TRIGGER"] = "allowed-countries-modal-filter-trigger-button";
    DATA_HOOKS["OPTIONS_BULK_EDIT_MODAL_INPUT_AREA"] = "options-bulk-edit-modal-input-area";
    DATA_HOOKS["ADD_PANEL_ITEM_TOOLTIP"] = "add-panel-item-tooltip";
    DATA_HOOKS["ADD_PANEL_ITEM"] = "add-panel-item";
    DATA_HOOKS["ADD_PANEL_ITEM_BUTTON"] = "add-panel-item-button";
    DATA_HOOKS["TOGGLE_TRUNCATE_BUTTON_READ_MORE"] = "toggle-truncate-button-read-more";
    DATA_HOOKS["TOGGLE_TRUNCATE_BUTTON_READ_LESS"] = "toggle-truncate-button-read-less";
    DATA_HOOKS["REGEX_SETTING_TOGGLE"] = "regex-setting-toggle";
    DATA_HOOKS["REGEX_SETTING_INPUT"] = "regex-setting-input";
    DATA_HOOKS["REGEX_SETTING_ERROR_MESSAGE_ADD_BUTTON"] = "regex-setting-error-message-add-button";
    DATA_HOOKS["REGEX_SETTING_ERROR_MESSAGE"] = "regex-setting-error-message";
    DATA_HOOKS["SUBMIT_BUTTON"] = "submit-button";
    DATA_HOOKS["POPOVER"] = "popover";
    DATA_HOOKS["OPTION_MENU_TRIGGER_BUTTON"] = "option-menu-trigger-button";
    DATA_HOOKS["DEFAULT_VALUE_TOGGLE"] = "default-value-toggle-switch";
    DATA_HOOKS["DEFAULT_VALUE_INPUT"] = "default-value-input";
    DATA_HOOKS["DEFAULT_VALUE_RADIO_GROUP"] = "default-value-radio-group";
    DATA_HOOKS["SCORE_SETTING_NUMBER_INPUT"] = "score-setting-number-input";
    DATA_HOOKS["OPTION_IMAGE_ASPECT_RATIO_DROPDOWN"] = "option-image-aspect-ratio-dropdown";
    DATA_HOOKS["OPTION_IMAGE_ALIGNMENT_TOGGLE"] = "option-image-alignment-toggle";
    return DATA_HOOKS;
}({});

//# sourceMappingURL=data-hooks.js.map